/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

import axios from 'axios';
import App from '../helpers/app';
import {is_breakpoint_up, scroll_to} from "../helpers/functions";

$(function () {
    let $calculateRequest = null;

    function initOffersEvents(){
        function populateChanges(){
            let $sectionList = $('.section-calculation-list');

            let financeType = $section.find('.section-nav .nav-link.active').data('input');
            let offerType = $section.find('[name="LeadOfferForm[offer_type]"]:checked').val();
            if(financeType=='rent'){
                $section.find('.group-packages').slideDown();
                $section.find('.group-repurchase').slideUp();
                $sectionList.find('.faq-rent').show();
                $sectionList.find('.faq-leasing').hide();

                if(offerType=='personal'){
                    $section.find('.group-contribution').slideUp();
                }else{
                    $section.find('.group-contribution').slideDown();
                }
            }else{
                $section.find('.group-packages').slideUp();
                $section.find('.group-repurchase').slideDown();
                $sectionList.find('.faq-rent').hide();
                $sectionList.find('.faq-leasing').show();
            }

            $section.removeClassStartsWith('finance-type-').addClass('finance-type-'+financeType);

            let dataIf = {'rent': 'najmu', 'leasing': 'leasingu', 'loan': 'kredytu'};
            $section.find('.texts-offer-dative').html(dataIf[financeType] ?? '');
            $section.find('.texts-tax').html(offerType=='company' && financeType!=='loan' ? 'netto' : 'brutto');

            let income = $section.find('[name="LeadOfferForm[income]"]').val();
            let costs = $section.find('[name="LeadOfferForm[costs]"]').val();
            let $monthlyPrice = (income - costs) * 0.4;
            if($monthlyPrice<0){
                $monthlyPrice = 0;
            }
            $section.find('.config-price .price-value').html($monthlyPrice);

            let contractPeriodsInput = $section.find('[name="LeadOfferForm[contract_period]"]');
            let contractPeriods = contractPeriodsInput.data('values');
            if(typeof contractPeriods[offerType]!=='undefined'){
                let slider = contractPeriodsInput.next()[0];
                if(slider && offerType != contractPeriodsInput.data('active')){
                    contractPeriodsInput.data('active', offerType);
                    slider.noUiSlider.updateOptions({range: contractPeriods[offerType]});
                }
            }
        }

        let $section = $('.section-calculation-config');
        if(!$section.length){
            return;
        }

        $section.find('.section-nav .nav-link').on('shown.bs.tab', function (e) {
            $form.submit();
        });

        let $form = $section.find('form');

        function updateSortAddress(){
            let $sortDir = $sort.find('[name="DynamicModel[dir]"]:checked').val()=='desc'?'-':'';
            let $sortBy = $sort.find('[name="DynamicModel[by]"]:checked').val();

            if(!$sortBy){
                return;
            }

            $.address.parameter('page', '');
            $.address.parameter('per-page', '');
            $.address.parameter('sort', $sortDir+''+$sortBy);
        }

        $section.find('input, select').off().change(function(){
            $form.submit();
        });

        let $sort = $('.section-calculation-list').find('.offers-sort');
        $sort.find('input').off().change(function(){
            let el = $(this);
            if(el.attr('name')=='DynamicModel[by]'){
                if($sort.find('[name="DynamicModel[dir]"]:checked').val()!=el.data('default-dir')){
                    $sort.find('[name="DynamicModel[dir]"][value="'+el.data('default-dir')+'"]').prop('checked', true).change();
                    $sort.find('[name="DynamicModel[dir]"][value="'+el.data('default-dir')+'"]').parent().click();
                }
            }

            $.address.autoUpdate(false);

            updateSortAddress();

            $.address.update();
            $.address.autoUpdate(true);
        });

        $form.off().submit(function (e) {
            e.preventDefault();

            let formData = $(this).serializeArray();

            $.address.autoUpdate(false);

            $.each($.address.parameterNames(), function(k, v){
                if (v.includes('packages')) {
                    $.address.parameter(v, '');
                }
            });

            let data = {};
            $.each(formData, function(k, v){
                if(v.name.indexOf('DynamicModel')!==-1){
                    return true;
                }

                let name = v.name.replace('LeadOfferForm', 'f');
                name = name.replace('[]', '').replace('f[', '').replace(']', '');

                if(typeof data[name]==='undefined'){
                    data[name] = [];
                }

                if(v.value==''){
                    return true;
                }


                data[name].push(v.value);
            });

            data['finance_type'] = [$section.find('.section-nav .nav-link.active').data('input')];

            $.each(data, function(k, v){
                v = v.join(',');

                if($.inArray(k, ['finance_type'])!==-1){
                    return true;
                }

                $.address.parameter(k, v);
            });

            let dataIf = {'rent': 'najem', 'leasing': 'leasing', 'loan': 'kredyt'};
            let path = '/kalkulator-'+(dataIf[data['finance_type'].join(',')] ?? '');

            $.address.path(path);

            updateSortAddress();

            populateChanges();

            $.address.history(false);
            $.address.update();
            $.address.autoUpdate(true);
            $.address.history(true);

            return false;
        });

        $('.section-calculation-list').find('.show-more .btn').off().click(function(){
            $('.section-calculation-list').addClass('show-all');
        });

        $('.section-calculation-list').find('.open-filters').off().click(function(){
            scroll_to($('.section-calculation-config'));
        });

        $(window).scroll(function () {
            $('.section-calculation-list').find('.open-filters').removeClass('show');

            if(!is_breakpoint_up('lg') && $(window).scrollTop()>($('.section-calculation-config').outerHeight() - $('.section-calculation-config .config-summary').outerHeight())){
                $('.section-calculation-list').find('.open-filters').addClass('show');
            }
        });

        $form.submit();
    }

    function initDynamicEvents(){
        let $section = $('.section-calculation-list');
        if(!$section.length){
            return;
        }

        initOffersEvents();
    }

    initDynamicEvents();

    function initEvents(){
        let $section = $('.section-calculation-list');
        if(!$section.length){
            return;
        }

        let prevUrl;
        $.address.change(function(e){
            let $section = $('.section-calculation-list');
            let url = $.address.details(e);

            if((!prevUrl || prevUrl.value!=url.value) && url.parameters['offer_type']){
                prevUrl = url;

                $section.addClass('is-loading');

                let $buttonLoader = $('.section-calculation-config').find('.calculation-config .config-submit .btn');

                App.loader.init($buttonLoader, 'button');

                if ($calculateRequest) {
                    $calculateRequest.cancel();
                }

                $calculateRequest = axios.CancelToken.source();

                axios.get($.address.value(), { cancelToken: $calculateRequest.token })
                    .then(function (response) {
                        let block = $('.app-content');
                        let html = $(response.data.page.html);

                        block.find('.section-calculation-list').remove();
                        block.append(html.filter('.section-calculation-list'));

                        initDynamicEvents();

                        App.init($('.section-calculation-list'));

                        App.loader.end($buttonLoader);
                    })
                    .catch(function () {

                    });
            }
        });
    }

    initEvents();
});
